<div class="sidenav" [ngClass]="{'collapsed-sidebar': isCollapsed, 'sidebar': !isCollapsed}">
    <mat-drawer-container class="drawer-container">
        <mat-drawer class="drawer side-bar-class" mode="side" opened>
            <div class="drawer__header">
                <div class="drawer__header--icon">
                    <div class="hamburger-menu">
                        <mat-icon class="chevron-button" [ngClass]="{'rotated': isCollapsed}"
                            (click)="toggleSidebar()">chevron_left</mat-icon>
                    </div>
                    <img class="ps4-icon" src="assets/images/dgaspc-logo.svg"
                        alt="Direcția Generală de Asistență Socială și Protecția Copilului" />
                    <div class="drawer__header--text">
                        <div class="drawer__header--text--title">{{appName}}</div>
                        <div class="drawer__header--text--title--minWidth">PS 4</div>
                        <div class="drawer__header--text--subtitle faded-text">
                            {{appDescription}}
                        </div>
                        <div class="drawer__header--text--subtitle--minWidth faded-text">
                            DGASPC S4
                        </div>
                    </div>
                    <div class="drawer__header--social-container">
                        <div class="drawer__header--social" (click)="redirectToinDeskPlatform()">
                            <i class="fa-solid fa-desktop pointer" style="color: #fff"></i>
                            <span class="drawer__header--social--text faded-text pointer">inDesk</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="drawer__buttons">
                <mat-accordion>
                    <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/registru.svg" alt="" />
                                    <span>Registratură</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.cerere.list')" class="menu-link"
                            routerLink="/cereri" [class.menu-active]="'/cereri' === activeOption"
                            (click)="setActive('/cereri')">
                            <img class="sidenav-request-btn" src="../../../../assets/icons/cereri.svg" alt="" />
                            <span>Cereri</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.documents.official-documents.list')"
                            class="menu-link" routerLink="/confirmare-documente"
                            [class.menu-active]="'/confirmare-documente' === activeOption"
                            (click)="setActive('/confirmare-documente')">
                            <img src="../../../../assets/icons/confirmed-docs.svg" alt="" />
                            <span>Confirmare Documente</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.notificari.list')"
                            class="settings-option-menu" routerLink="/notificari"
                            [class.menu-active]="'/notificari' === activeOption" (click)="setActive('/notificari')">
                            <img src="/assets/icons/notificari.svg" alt="" />
                            <span>Notificări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.activities.list')" class="menu-link"
                            routerLink="/programari-calendar"
                            [class.menu-active]="'/programari-calendar' === activeOption"
                            (click)="setActive('/programari-calendar')">
                            <img src="../../../../assets/icons/programari.svg" alt="" />
                            <span>Programări</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/settings"
                            [class.menu-active]="'/settings' === activeOption" (click)="setActive('/settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.dashboard.list') || 
                        permissionsService.hasPermission('dgaspc-module.ajutoare.etape.list') ||
                        permissionsService.hasPermission('dgaspc-module.ajutoare.loturi.list')
                    " class="sidenav-accordion" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <!-- <mat-icon style="font-size:20px;width:20px;height:20px;margin-right:8px;color:#C0C0C0">account_balance</mat-icon> -->
                                    <img class="big" src="../../../../assets/icons/gestiuni-ajutoare.svg" alt="" />
                                    <span>Gestiune Ajutoare</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.dashboard.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/dashboard"
                            [class.menu-active]="'/gestiune-ajutoare/dashboard' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/dashboard')">
                            <!-- <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:8px;color:#C0C0C0">dashboard</mat-icon> -->
                            <img class="big" src="../../../../assets/icons/dashboard.svg" alt="" />
                            <span>Dashboard</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.etape.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/etape"
                            [class.menu-active]="'/gestiune-ajutoare/etape' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/etape')">
                            <!-- <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:8px;color:#C0C0C0">list_alt</mat-icon> -->
                            <img class="big" src="../../../../assets/icons/etape.svg" alt="" />
                            <span>Etape în lucru</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.loturi.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/loturi"
                            [class.menu-active]="'/gestiune-ajutoare/loturi' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/loturi')">
                            <!-- <mat-icon style="font-size:18px;width:18px;height:18px;margin-right:8px;color:#C0C0C0">folder</mat-icon> -->
                            <img class="big" src="../../../../assets/icons/loturi.svg" alt="" />
                            <span>Loturi decontare</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.loturi.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/loturi-invalidare"
                            [class.menu-active]="'/gestiune-ajutoare/loturi-invalidare' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/loturi-invalidare')">
                            <img class="big" src="../../../../assets/icons/loturi.svg" alt="" />
                            <span>Loturi invalidare</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.dashboard.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/rapoarte"
                            [class.menu-active]="'/gestiune-ajutoare/rapoarte' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/rapoarte')">
                            <img class="big" src="../../../../assets/icons/dashboard.svg" alt="" />
                            <span>Rapoarte</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.ajutoare.dashboard.list')"
                            class="menu-link" routerLink="/gestiune-ajutoare/pre-validare"
                            [class.menu-active]="'/gestiune-ajutoare/pre-validare' === activeOption"
                            (click)="setActive('/gestiune-ajutoare/pre-validare')">
                            <img class="big" src="../../../../assets/icons/dashboard.svg" alt="" />
                            <span>Pre-validare</span>
                        </p>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="env.production !== true" class="sidenav-accordion"
                        (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/programari.svg" alt="" />
                                    <span>Activități</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.programari.list-all')"
                            class="menu-link" routerLink="/contracte-programari"
                            [class.menu-active]="'/contracte-programari' === activeOption"
                            (click)="setActive('/contracte-programari')">
                            <img src="../../../../assets/icons/programari.svg" alt="" />
                            <span>Contracte programări</span>
                        </p>
                        <!-- <p *ngIf="permissionsService.hasPermission('dgaspc-module.copii.list')" class="menu-link"
                            routerLink="/copii" [class.menu-active]="'/copii' === activeOption"
                            (click)="setActive('/copii')">
                            <img src="../../../../assets/icons/user-icon.svg" alt="" />
                            <span>Copii</span>
                        </p> -->
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.copii.list')" class="menu-link"
                            routerLink="/beneficiari" [class.menu-active]="'/beneficiari' === activeOption"
                            (click)="setActive('/beneficiari')">
                            <img src="../../../../assets/icons/user-icon.svg" alt="" />
                            <span>Beneficiari</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.scans.list')" class="menu-link"
                            routerLink="/scans" [class.menu-active]="'/scans' === activeOption"
                            (click)="setActive('/scans')">
                            <img src="../../../../assets/icons/docs.svg" alt="" />
                            <span>Scanări</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.program.list')" class="menu-link"
                            routerLink="/program" [class.menu-active]="'/program' === activeOption"
                            (click)="setActive('/program')">
                            <img src="../../../../assets/icons/borderou.svg" alt="" />
                            <span>Program</span>
                        </p>
                        <p *ngIf="permissionsService.hasPermission('dgaspc-module.inregistrare-programare.list')"
                            class="menu-link" routerLink="/inregistrare-programare"
                            [class.menu-active]="'/inregistrare-programare' === activeOption"
                            (click)="setActive('/inregistrare-programare')">
                            <img src="../../../../assets/icons/registru.svg" alt="" />
                            <span>Înregistrare Programare</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/settings-activities"
                            [class.menu-active]="'/settings-activities' === activeOption"
                            (click)="setActive('/settings-activities')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări - Beneficiari</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/settings-activities-docs"
                            [class.menu-active]="'/settings-activities-docs' === activeOption"
                            (click)="setActive('/settings-activities-docs')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări - Documente</span>
                        </p>
                        <p class="settings-option-menu" routerLink="/settings-activities-prog"
                            [class.menu-active]="'/settings-activities-prog' === activeOption"
                            (click)="setActive('/settings-activities-prog')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări - Programări</span>
                        </p>
                    </mat-expansion-panel>

                    <mat-expansion-panel class="sidenav-accordion" (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header class="sidenav-accordion" [class.hide-line]="panelOpenState">
                            <mat-panel-title class="sidenav-accordion">
                                <div class="panel-title">
                                    <img src="../../../../assets/icons/administrative.svg" alt="" />
                                    <span>Administrativ</span>
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p class="settings-option-menu" routerLink="/admin-settings"
                            [class.menu-active]="'/admin-settings' === activeOption"
                            (click)="setActive('/admin-settings')">
                            <img src="../../../../assets/icons/setari.svg" alt="" />
                            <span>Setări</span>
                        </p>
                    </mat-expansion-panel>
                </mat-accordion>

                <div class="footer">
                    <div class="col-sm-12 px-2" [class.hidden]="isCollapsed == true">
                        <small [innerHTML]="env.config.copyrightText"></small>
                    </div>
                    <div class="logout-button" (click)="logout()">
                        <img src="assets/icons/logout.svg" alt="Deconectare" />
                        <div click="logout()" class="logout-button--text">Deconectare</div>
                    </div>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content class="drawer-content" [style.marginLeft.px]="isCollapsed ? 85 : 280">
            <router-outlet></router-outlet>
        </mat-drawer-content>
    </mat-drawer-container>
</div>